import { render, staticRenderFns } from "./RoleInput.vue?vue&type=template&id=334303c7"
import script from "./RoleInput.vue?vue&type=script&lang=js"
export * from "./RoleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports